import React, { FunctionComponent, useEffect, useState, useRef, useMemo } from 'react';
import FixedTable from '../table/fixedTable'
import { Carousel } from 'antd'
import { article } from '@Api';
import { ChartsType, ICharts, tabType } from '../context';
import cx from 'classnames';
import styles from './index.module.less';

interface IProps {
  charts: ChartsType;
  dataSource: ICharts['chartData']
}

const Tab: FunctionComponent<IProps> = ({ charts, dataSource }) => {
  const [index, setIndex] = useState<number>(0);
  const [relationChartId, setId] = useState<number>(0);
  const carouselRef = useRef<Carousel>(null);

  const data = useMemo(() => dataSource[0] as tabType[], [dataSource]);

  const validateData = (data: any, key: number) => {
    if (data?.[key] && data?.[key]?.chartData && data?.[key]?.chartData.length !== 0) {
      return charts?.[key] as ICharts
    }
    return false
  }

  const tableData = useMemo(() => {
    return validateData(charts, relationChartId)
  }, [charts, relationChartId]);

  const paging = ((dir: number) => {
    const { current } = carouselRef
    if (!current) {
      return
    }
    if (dir === 1) {
      try {
        current.next();
      } catch (e) {
      }
    } else if (dir === -1) {
      try {
        current.prev();
      } catch (e) {
      }
    }
  })

  useEffect(() => {
    if (dataSource.length !== 0 && dataSource[0]?.length !== 0) {
      setId(dataSource[0][0].relationChartId)
    }
  }, [dataSource])

  return (
    <div className={styles["tab"]}>
      <div className={styles['tab-bar']}>
        {
          data.map((item, inx) => (
            <div 
              className={cx(styles['tab-item'], {[styles['active']]: inx === index})} 
              onClick={() => {
                setIndex(inx);
                setId(item.relationChartId);
              }}
              key={inx}>
                {item.title}
            </div>
          ))
        }
      </div>
      <div className={styles['tab-carousel']}>
        { data[index]?.values.length > 1 && <div className={styles['prev']} onClick={() => paging(-1)}></div>}
        {
          data[index]?.values.length > 1 ?
          <Carousel
            className={styles['carousel']}
            autoplay={true}
            ref={carouselRef}
          >
            {(data[index]?.values as string[])?.map((item, i) => (
              <img src={item} key={i} className={cx(styles['slide-item'])} alt="" />
            ))}
          </Carousel> :
          <img className={styles['carousel-img']} src={data[index]?.values as string} alt="" />
        }
        { data[index]?.values.length > 1 && <div className={styles['next']} onClick={() => paging(1)}></div> }
      </div>
      <div className={styles['tab-table']}>
        { tableData && <FixedTable dataSource={tableData} /> }
      </div>
    </div>
  )
}

export default Tab;
